import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { auth } from './utils/firebase-config';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { lightTheme, darkTheme } from './theme';
import TopBar from './components/layout/TopBar';
import Sidebar from './components/layout/Sidebar';
import BackButton from './components/layout/BackButton';
import AppRoutes from './routes/AppRoutes';
import { UserContext } from './context/UserContext';
import UpdateNotification from './UpdateNotification';
import { NotificationProvider } from './context/NotificationContext';
import ErrorBoundaryWrapper from './components/common/ErrorBoundaryWrapper';

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Opcional: Leer preferencia inicial del localStorage
    const savedMode = localStorage.getItem('darkMode');
    return savedMode === 'true';
  });
  const { currentUser } = useContext(UserContext); // Asegúrate que UserProvider envuelve a App

  useEffect(() => {
    // Guardar preferencia de modo oscuro en localStorage
    localStorage.setItem('darkMode', isDarkMode);
  }, [isDarkMode]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLogout = () => {
    auth.signOut().catch(error => {
      // Opcional: Mostrar notificación si falla el logout
      console.error("Error al cerrar sesión:", error);
    });
  };

  const toggleTheme = () => {
    setIsDarkMode(prevMode => !prevMode);
  };

  // Seleccionar el tema basado en el estado isDarkMode
  const currentTheme = isDarkMode ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      <Router>
        <ErrorBoundaryWrapper>
          <NotificationProvider>
            <UpdateNotification />

            {currentUser && (
              <>
                <TopBar
                  handleMenuClick={toggleSidebar}
                  handleLogout={handleLogout}
                  handleThemeToggle={toggleTheme}
                  isDarkMode={isDarkMode}
                />
                <Sidebar open={isSidebarOpen} onClose={toggleSidebar} />
              </>
            )}

            <main style={{ paddingTop: currentUser ? '64px' : '0' }}>
              <AppRoutes />
            </main>

            {currentUser && <BackButton label="Regresar" />}

          </NotificationProvider>
        </ErrorBoundaryWrapper>
      </Router>
    </ThemeProvider>
  );
}

export default App;